import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => {
	const imageRadius = "0.5rem";

	return {
		productItemWrapper: {
			position : "relative",
			cursor   : "pointer",
			minWidth : "initial"
		},
		productImage: {
			borderRadius : "1rem",
			border       : `1px solid ${ theme.other.colors.darkGray20 }`
		},
		image: {
			boxShadow    : theme.shadows.sm,
			aspectRatio  : "1/1",
			borderRadius : imageRadius
		},
		figure: {
			width: "100%"
		},
		placeholder: {
			borderRadius: imageRadius
		},
		imageSkeleton: {
			borderRadius : imageRadius,
			height       : "100%",
			width        : "100%"
		},
		carouselContainer: {
			paddingInline: "1rem"
		},
		carouselRoot: {
			width    : "100vw",
			position : "relative",
			left     : "-2rem"
		},
		productDetails: {
			alignItems: "center"
		},
		offersIcon: {
		},
		productItemFooter: {
			color: theme.other.colors.successGreen
		},
		imageWrapper: {
			position     : "relative",
			borderRadius : imageRadius,
			aspectRatio  : "1/1"
		},
		wishlistIconWrapper: {
			width       : "1rem",
			aspectRatio : "1/1"
		},
		iconWrapper: {
			bottom         : "5%",
			right          : "5%",
			overflow       : "hidden",
			position       : "absolute",
			gap            : "0.2rem",
			transition     : "all 0.3s",
			aspectRatio    : "1/1",
			borderRadius   : "1rem",
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center"
		},
		exploreBtn: {
			width       : "fill-available",
			marginBlock : "2rem 0rem"
		},
		desktopGrid: {
			gap      : "1.6rem",
			display  : "flex",
			flexWrap : "wrap",
			"> *"    : {
				flex     : "1",
				maxWidth : "210px"
			}
		}
	};
} );